class DataUtil {
  static getDiaSemana(diaSemana: number): string {
    switch(diaSemana) {
      case 0: return "Domingo";
      case 1: return "Segunda-feira";
      case 2: return "Terça-feira";
      case 3: return "Quarta-feira";
      case 4: return "Quinta-feira";
      case 5: return "Sexta-feira";
      case 6: return "Sábado";
    }
    return "";
  }

  static getIdade(nasc: string): number {
    var todayDate = new Date().getTime();
    
    const parts = nasc.split("/");
    const dtNascimento = new Date(parseInt(parts[2], 10),
                      parseInt(parts[1], 10) - 1,
                      parseInt(parts[0], 10));

    var birthDate = new Date(dtNascimento).getTime();
    var age = (todayDate - birthDate) / (1000 * 60 * 60 * 24 * 365)
  
    return age;
  }
  static getDiaSemanaMin(diaSemana: number): string {
    switch(diaSemana) {
      case 0: return "Dom";
      case 1: return "Seg";
      case 2: return "Ter";
      case 3: return "Qua";
      case 4: return "Qui";
      case 5: return "Sex";
      case 6: return "Sáb";
    }
    return "";
  }

  static toUsDate(nasc: string) {
    const parts = nasc.split("/");
    const usDate = new Date(parseInt(parts[2], 10),
                      parseInt(parts[1], 10) - 1,
                      parseInt(parts[0], 10));
    return usDate.toISOString().split('T')[0];
  }

  static getDMA(date: Date): string {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }

  static getDiaDMA(date: Date): string {
    return date.getDate().toString();
  }

  static getDiaSemanaDMA(date: Date): string {
    let hoje: Date = new Date();
    if (date.getDate() === hoje.getDate() &&
      date.getMonth() === hoje.getMonth() &&
      date.getFullYear() === hoje.getFullYear()) {
      return "Hoje";
    } else {
      return DataUtil.getDiaSemanaMin(date.getDay());
    }
  }

  static addDias(data: Date, dias: number): Date {
    var date = new Date(data.valueOf());
    date.setDate(date.getDate() + dias);
    date.setHours(0,0,0);
    return date;
  }
}

export default DataUtil;

